import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {InventoryTransactionContainerModel} from "../../../../../../models/aggregates/erp/inventory-transaction";

@Injectable({providedIn: 'root'})
export class InventoryTransactionsService extends BaseApiTemplateService<InventoryTransactionContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-transactions';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-transactions';
    this.httpClient = http;
  }

}
